import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c0ae291"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plan-details-card-header justify-content-center plan-amount" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "d-flex justify-center mt-n8 pb-4" }, "Get JtelFiber", -1))
const _hoisted_3 = {
  key: 0,
  class: "note text-center mt-4 px-6"
}
const _hoisted_4 = { class: "mt-6" }
const _hoisted_5 = { class: "mb-3 px-4" }
const _hoisted_6 = { class: "mb-3 px-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-1 color-red" }, [
  /*#__PURE__*/_createElementVNode("b", null, "*")
], -1))
const _hoisted_8 = { class: "mb-3 px-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-1 color-red" }, [
  /*#__PURE__*/_createElementVNode("b", null, "*")
], -1))
const _hoisted_10 = { class: "mb-3 px-4" }
const _hoisted_11 = { class: "mb-6 px-4" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = {
  key: 1,
  class: "text-center mt-12"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-6 mx-6 font-xs" }, "We have received your request for new Jtel broadband connection. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 mx-6 mb-10" }, "Our Team will get in touch with you shortly. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "plan-details-card" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_card_actions, { class: "d-flex align-end flex-column mt-n2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "primary",
              icon: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closePopup()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  style: {"color":"#ffff"},
                  class: "pa-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-close")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_2
      ]),
      (!$setup.success)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createTextVNode("Just validate your number, share your address, and we'll get JtelFiber installed at you place soon. "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.detail.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.detail.name) = $event)),
                  density: "compact",
                  variant: "solo",
                  label: "Name",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.detail.phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.detail.phone) = $event)),
                  density: "compact",
                  variant: "solo",
                  "hide-details": "",
                  class: _normalizeClass({ 'border-red': $setup.submitted && ($setup.detail.phone.trim() == '' || !$setup.isValidPh) }),
                  onKeyup: _cache[3] || (_cache[3] = ($event: any) => ($setup.validatePhoneNumber()))
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(" Phone Number "),
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["modelValue", "class"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.detail.email,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.detail.email) = $event)),
                  density: "compact",
                  variant: "solo",
                  "hide-details": "",
                  class: _normalizeClass({ 'border-red': $setup.submitted && ($setup.detail.email.trim() == '' || !$setup.isValidEmail) }),
                  onKeyup: _cache[5] || (_cache[5] = ($event: any) => ($setup.validateEmail()))
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(" Email "),
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["modelValue", "class"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.detail.place,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.detail.place) = $event)),
                  density: "compact",
                  variant: "solo",
                  label: "Place",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.detail.address,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.detail.address) = $event)),
                  density: "compact",
                  variant: "solo",
                  label: "Address",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_v_btn, {
                  class: "btn-primary w-full",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.sendMail()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_v_btn, {
              icon: "mdi-thumb-up",
              color: "success",
              style: {"height":"70px","width":"70px"}
            }),
            _hoisted_14,
            _hoisted_15,
            _createVNode(_component_v_btn, {
              class: "bg-red",
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.closePopup()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Close")
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}